import { Anchor } from "../../../../src/components/Anchor.tsx";
import * as React from 'react';
export default {
  Anchor,
  React
};